<template>
  <div class="mainAuxPage zj-flex-column">
    <!-- 卡片 -->
    <div class="zj-flex-row"
      style="border: 1.5px solid rgb(221 221 221);flex: 1;background-color: white;margin-bottom: 10px;box-shadow: 0 0 3px rgba(188, 186, 186, 0.8);">
      <div class="zj-flex-row" style="margin: 0 5px;flex: 1;">
        <div class="zj-flex-row hvr-grow-shadow" style="background-color: #e35e00;margin: 8px 12px;border-radius: 3%;"
          @click="gotoLectureManage()">
          <div class="text-inner">
            <span style="display: flex;flex: 0.3;"></span>
            <span style="color: #FFFFFF;font-size: 37px;display: flex;flex: 1;font-weight: bold;">{{ LectureNum
            }}</span>
            <span style="color: #FFFFFF;font-size:20px;display: flex;flex: 1;">个人大赛数量</span>
          </div>
          <div class="card-inner"><img style="width: 50px;height: 50px;;display: flex;" src="/static/base/img/培训申请1.png">
          </div>
        </div>
        <div class="zj-flex-row hvr-grow-shadow" style="background-color: #1f96b2;margin: 8px 12px;border-radius: 3%;">
          <div class="text-inner">
            <span style="display: flex;flex: 0.3;"></span>
            <span style="color: #FFFFFF;font-size: 37px;display: flex;flex: 1;font-weight: bold;">{{ LectureAllowNum
            }}</span>
            <span style="color: #FFFFFF;font-size:20px;display: flex;flex: 1;">大赛待审核队伍</span>
          </div>
          <div class="card-inner"><img style="width: 50px;height: 50px;;display: flex;" src="/static/base/img/24_学生.png">
          </div>
        </div>
        <div class="zj-flex-row hvr-grow-shadow" style="background-color: #5675bf;margin: 8px 12px;border-radius: 3%;"
          @click="gotoCourse()">
          <div class="text-inner">
            <span style="display: flex;flex: 0.3;"></span>
            <span style="color: #FFFFFF;font-size: 37px;display: flex;flex: 1;font-weight: bold;">{{ courseNum }}</span>
            <span style="color: #FFFFFF;font-size:20px;display: flex;flex: 1;">个人课程数量</span>
          </div>
          <div class="card-inner "><img style="width: 50px;height: 50px;;display: flex;"
              src="/static/base/img/online-communication2.png">
          </div>
        </div>
        <div class="zj-flex-row hvr-grow-shadow" style="background-color: #029bdd;margin: 8px 12px;border-radius: 3%;">
          <div class="text-inner">
            <span style="display: flex;flex: 0.3;"></span>
            <span style="color: #FFFFFF;font-size: 37px;display: flex;flex: 1;font-weight: bold;">{{ courseAllowNum
            }}</span>
            <span style="color: #FFFFFF;font-size:20px;display: flex;flex: 1;">课程待审核学生</span>
          </div>
          <div class="card-inner"><img style="width: 50px;height: 50px;;display: flex;"
              src="/static/base/img/w_学生-64.png">
          </div>
        </div>
        <div class="zj-flex-row hvr-grow-shadow" style="background-color: #894db8;margin: 8px 12px;border-radius: 3%;">
          <div class="text-inner">
            <span style="display: flex;flex: 0.3;"></span>
            <span style="color: #FFFFFF;font-size: 37px;display: flex;flex: 1;font-weight: bold;">{{ signNum }}</span>
            <span style="color: #FFFFFF;font-size:20px;display: flex;flex: 1;">未签到人数</span>
          </div>
          <div class="card-inner"><img style="width: 50px;height: 50px;;display: flex;" src="/static/base/img/签到.png">
          </div>
        </div>
        <div class="zj-flex-row hvr-grow-shadow" style="background-color: #31a28e;margin: 8px 12px;border-radius: 3%;">
          <div class="text-inner">
            <span style="display: flex;flex: 0.3;"></span>
            <span style="color: #FFFFFF;font-size: 37px;display: flex;flex: 1;font-weight: bold;">{{ homeworkNum
            }}</span>
            <span style="color: #FFFFFF;font-size:20px;display: flex;flex: 1;">待批改作业数</span>
          </div>
          <div class="card-inner"><img style="width: 50px;height: 50px;;display: flex;" src="/static/base/img/作业-选中.png">
          </div>
        </div>
      </div>
    </div>
    <!-- 我的讲座/我的课程 -->
    <div class="zj-flex-row" style="flex: 3;">
      <div
        style="border: 1.5px solid rgb(221 221 221);display: flex;flex: 1;margin-right: 7px; box-shadow: 0 0 3px rgba(188, 186, 186, 0.8);">
        <div class="zj-flex-column">
          <div class="zj-tbar"
            style="margin-bottom: 0;background-color: #e5e5e5;border-bottom: 3px solid rgb(221 221 221);">
            <div class="zj-flex-row" style="justify-content: space-between;align-items: center;">
              <div style="display: flex;flex-direction: row;margin: 5px 10px;align-items: center;">
                <div class="zj-flex-ceter">
                  <i style="font-size: 30px;margin-right: 10px;color: #409EFF;" class="el-icon-s-platform"></i>
                </div>
                <div style="font-weight: 600;color: #409EFF;">我的大赛</div>
              </div>
              <div style="display: flex;flex-direction: row;margin-right: 10px;">
                <el-button icon="el-icon-more" title="更多" size="mini" circle @click="gotoLecture(1)"></el-button>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" circle @click="refreshLectureData()"></el-button>
              </div>
            </div>
          </div>
          <div style="padding:5px 30px;display: flex;flex: 1;background-color: white;">
            <zj-table ref="lectureTable" :data="lectureData" :show-header="false" :border="false"
              :highlight-current-row="false" @row-dblclick="openLectureDetail"
              :row-style="{ height: '40px', color: '#8d9196' }">
              <el-table-column prop="p_no" label="比赛编码" align="center" show-overflow-tooltip
                width="180px"></el-table-column>
              <el-table-column prop="p_name" label="比赛名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="" label="" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.competition_startdate | dateFilter('yyyy-MM-dd HH:mm') }} ~ {{scope.row.competition_enddate | dateFilter('yyyy-MM-dd HH:mm') }}
                </template>
              </el-table-column>
              <!-- <el-table-column prop="pp_location" label="地点" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="讲座时间" prop="pp_date" align="center" width="200px">
                <template slot-scope="scope">
                  <div class="zj-flex-row">
                    <div style="display: flex;align-items: center;">
                      <div v-if="scope.row.pp_date != null">
                        {{ scope.row.pp_date | dateFilter("yyyy/MM/dd") }} {{ '第' +
                          scope.row.pp_section_seq.split(',')[0] +
                          '~' + scope.row.pp_section_seq.split(',')[1] +
                          '节'
                        }}
                      </div>
                      <div v-else> {{ "无 " }}</div>
                    </div>
                    <div style="display: flex;align-items: center;margin-right: 5px;"
                      v-if="(new Date().getTime() - new Date(scope.row.pp_date).getTime()) / (1000 * 3600 * 24) < 1">
                      &nbsp;&nbsp; <img style="width: 20px;height: 20px;" src="/static/base/img/today.png">
                    </div>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column width="40" align-items="center">
                <template slot-scope="scope">
                  <div class="zj-flex-center">
                    <i style="color:#409EFF;font-size: 16px;" class="el-icon-info"
                      @click="openLectureDetail(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="-1"></el-table-column>
            </zj-table>
          </div>
        </div>
      </div>
      <div
        style="border: 1.5px solid rgb(221 221 221);display: flex;flex: 1;margin-left: 7px;box-shadow: 0 0 3px rgba(188, 186, 186, 0.8);">
        <div class="zj-flex-column">
          <div class="zj-tbar"
            style="margin-bottom: 0;background-color: #e5e5e5;border-bottom: 3px solid rgb(221 221 221);">
            <div class="zj-flex-row" style="justify-content: space-between;align-items: center;">
              <div style="display: flex;flex-direction: row;margin: 5px 10px;align-items: center;">
                <div class="zj-flex-ceter">
                  <i style="font-size: 30px;margin-right: 10px;color: #409EFF;" class="el-icon-s-marketing"></i>
                </div>
                <div style="font-weight: 600;color: #409EFF;">我的活动</div>
              </div>
              <div style="display: flex;flex-direction: row;margin-right: 10px;">
                <el-button icon="el-icon-more" title="更多" size="mini" circle @click="gotoLecture(2)"></el-button>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" circle @click="refreshCourseData()"></el-button>
              </div>
            </div>
          </div>
          <div style="padding:5px 30px;display: flex;flex: 1;background-color: white;">
            <!-- <zj-table ref="courseTable" class="custom-table" :data="courseData" :show-header="false" :border="false"
              :highlight-current-row="false" :row-style="{ height: '40px', color: '#8d9196' }"
              @row-dblclick="openCourseDetail">
              <el-table-column prop="p_no" label="课程编码" align="center" show-overflow-tooltip
                width="120px"></el-table-column>
              <el-table-column prop="p_name" label="课程名称" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="num" label="学生人数" align="center" show-overflow-tooltip width="170px">
                <template slot-scope="scope">
                  <div class="zj-flex-row">
                    <div style="display: flex;align-items: center;">
                      学生人数：{{ scope.row.num }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="60" align-items="center">
                <template slot-scope="scope">
                  <div class="zj-flex-center">
                    <i style="color: #409EFF;font-size: 16px;" class="el-icon-info"
                      @click="openCourseDetail(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="-1"></el-table-column>
            </zj-table> -->
            <zj-table ref="courseTable" :data="courseData" :show-header="false" :border="false"
              :highlight-current-row="false" @row-dblclick="openLectureDetail"
              :row-style="{ height: '40px', color: '#8d9196' }">
              <el-table-column prop="p_no" label="活动编码" align="center" show-overflow-tooltip
                width="180px"></el-table-column>
              <el-table-column prop="p_name" label="活动名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="" label="" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.competition_startdate | dateFilter('yyyy-MM-dd HH:mm') }} ~ {{scope.row.competition_enddate | dateFilter('yyyy-MM-dd HH:mm') }}
                </template>
              </el-table-column>
              <el-table-column width="40" align-items="center">
                <template slot-scope="scope">
                  <div class="zj-flex-center">
                    <i style="color:#409EFF;font-size: 16px;" class="el-icon-info"
                      @click="openLectureDetail(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="-1"></el-table-column>
            </zj-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 讲座详情 -->
    <el-dialog width="750px" title="详情"  :visible.sync="showLectureDetail">
      <zj-form :model="lectureContent" label-width="150px" ref="lectureForm">
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="编码:" prop="p_no" style="width:650px;">{{ lectureContent.p_no
          }}</el-form-item>
          <el-form-item class="custom-form-item" label="名称:" prop="p_name" style="width:650px;">{{ lectureContent.p_name
          }}</el-form-item>
          <!-- <el-form-item class="custom-form-item" label="讲座地点:" prop="pp_location" style="width:370px;">{{
            lectureContent.pp_location
          }}</el-form-item> -->
        </div>
        <!-- <div class="dialog-form">
          <el-form-item class="custom-form-item" label="讲师:" prop="emp_name" style="width:370px;">{{
            lectureContent.emp_name }}</el-form-item>
          <el-form-item class="custom-form-item" label="研究领域:" prop="emp_researchfiled" style="width:370px;">{{
            lectureContent.emp_researchfiled
          }}</el-form-item>
        </div> -->
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="报名开始时间:" prop="competition_startdate" style="width:650px;">{{
            lectureContent.competition_startdate | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
          <el-form-item class="custom-form-item" label="报名结束时间:" prop="competition_enddate" style="width:650px;">{{
            lectureContent.competition_enddate | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
        </div>
        <!-- <div class="dialog-form">
          <el-form-item class="custom-form-item" label="讲座日期:" prop="pp_date" style="width:370px;">{{
            lectureContent.pp_date |
            dateFilter('yyyy-MM-dd') }}</el-form-item>
          <el-form-item class="custom-form-item" label="节次:" prop="pp_section_seq" style="width:370px;">{{ '第' +
            lectureContent.pp_section_seq +
            '节' }}</el-form-item>
        </div> -->
        <!--  <el-form-item class="custom-form-item" label="主题标签:" prop="checkLabel" style="width: 740px">
          <template>
            <div style="display:flex;flex:1;flex-direction:row;flex-flow:wrap">
              <div v-for="item in checkLabel" style="margin:0 10px">
                <el-tag>{{ item }}</el-tag>
              </div>
            </div>
          </template>
        </el-form-item> -->
        <div class="dialog-form">
          <el-form-item label="介绍:" prop="p_note" style="width: 650px;">
            <template>
              <div
                style="display:flex;flex:1;flex-direction:row;flex-flow:wrap;letter-spacing:0.1em;line-height:18px;align-items: center;min-height: 40px;">
                {{ lectureContent.p_note }}
              </div>
            </template>
          </el-form-item>
        </div>
      </zj-form>
    </el-dialog>
    <el-dialog width="750px" title="课程详情"  :visible.sync="showCourseDetail">
      <zj-form :model="courseContent" label-width="150px" ref="courseForm">
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="课程名称：" prop="p_name" style="width:650px;">{{ courseContent.p_name
          }}</el-form-item>
          <!-- <el-form-item class="custom-form-item" label="讲师：" prop="emp_name" style="width:650px;">{{
            courseContent.emp_name }}</el-form-item> -->
        </div>
        <div class="dialog-form">
          <el-form-item label="课程说明：" prop="p_note" style="width:650px;">
            <template>
              <div
                style="display:flex;flex:1;flex-direction:row;flex-flow:wrap;letter-spacing:0.1em;line-height:18px;align-items: center;min-height: 40px;">
                {{ courseContent.p_note }}
              </div>
            </template>
          </el-form-item>
          <!-- <el-form-item label="课程说明：" prop="p_note" style="width:370px;">{{ lectureContent.p_note }}</el-form-item> -->

        </div>
        <div class="dialog-form">
          <el-form-item class="custom-form-item" label="报名开始时间：" prop="competition_startdate" style="width:650px;">{{
            courseContent.competition_startdate | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
          <el-form-item class="custom-form-item" label="报名结束时间：" prop="competition_enddate" style="width:650px;">{{
            courseContent.competition_enddate | dateFilter('yyyy-MM-dd HH:mm') }}</el-form-item>
        </div>
      </zj-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vueQr from 'vue-qr';

export default {
  components: {
    vueQr,
  },

  data() {
    return {
      lectureData: [],
      courseData: [],
      showLectureDetail: false,
      showCourseDetail: false,
      lectureContent: {},
      courseContent: {},
      checkLabel: [],
      courseNum: 0,
      homeworkNum: 0,
      courseAllowNum: 0,
      LectureNum: 0,
      signNum: 0,
      LectureAllowNum: 0,
    };
  },
  computed: {
    ...mapState(["accountInfo"]),
  },
  methods: {
    //刷新表格数据（带筛选条件）
    refreshLectureData() {
      this.lectureData = [];
      this.z_get(
        "api/project/getMyCompetitionLimit", //如果是树结构数据，必须返回datatable
        {
          condition: this.condition, //左侧为后台参数名，右侧为前端参数名，需配对
          limitNum: 10,
          emp_id: this.accountInfo.emp_id,   //暂不限制
          project_type: 1
        },
        { loading: this.$refs.lectureTable } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标
      )
        .then(res => {
          this.lectureData = res.data;
          function compare(property) {
            return function (a, b) {
              var value1 = a[property];
              var value2 = b[property];
              return new Date(value2).getTime() - new Date(value1).getTime();  //降序只需要  return value2- value1
            }
          }
          this.lectureData.sort(compare('pp_date'))
        })
        .catch(res => { });
    },
    refreshCardData() {
      this.z_get(
        "api/project/getCardData", //如果是树结构数据，必须返回datatable
        {
          emp_id: this.accountInfo.emp_id,
        },
        { loading: true } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标
      )
        .then(res => {
          let model = res.data[0];
          // console.log(model,'model',model.LectureAllowNum);
          if (model.signNum > 0) this.signNum = model.signNum;
          else this.signNum = "/";
          if (model.courseNum > 0) this.courseNum = model.courseNum;
          else this.courseNum = "/";
          if (model.lectureNum > 0) this.LectureNum = model.lectureNum;
          else this.LectureNum = "/";
          if (model.homeworkNum > 0) this.homeworkNum = model.homeworkNum;
          else this.homeworkNum = "/";
          if (model.courseAllowNum > 0) this.courseAllowNum = model.courseAllowNum;
          else this.courseAllowNum = "/";
          if (model.lectureAllowNum > 0) this.LectureAllowNum = model.lectureAllowNum;
          else this.LectureAllowNum = "/";
          // console.log(this.LectureNum,this.LectureAllowNum,111);
        })
        .catch(res => { });
    },
    //刷新表格数据（带筛选条件）
    refreshCourseData() {
      // this.courseData = [];
      // this.z_get(
      //   "api/project/getCourseLimit",
      //   {
      //     limitNum: 10
      //   },
      //   { loading: this.$refs.courseTable } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标
      // )
      //   .then(res => {
      //     this.courseData = res.data
      //     function compare(property) {
      //       return function (a, b) {
      //         var value1 = a[property];
      //         var value2 = b[property];
      //         return new Date(value2).getTime() - new Date(value1).getTime();  //降序只需要  return value2- value1
      //       }
      //     }
      //     this.courseData.sort(compare('competition_startdate'))
      //   })
      //   .catch(res => { });
        this.courseData = [];
      this.z_get(
        "api/project/getMyCompetitionLimit", //如果是树结构数据，必须返回datatable
        {
          condition: this.condition, //左侧为后台参数名，右侧为前端参数名，需配对
          limitNum: 10,
          emp_id: this.accountInfo.emp_id,   //暂不限制
          project_type: 2
        },
        { loading: this.$refs.courseTable } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标
      )
        .then(res => {
          this.courseData = res.data;
          function compare(property) {
            return function (a, b) {
              var value1 = a[property];
              var value2 = b[property];
              return new Date(value2).getTime() - new Date(value1).getTime();  //降序只需要  return value2- value1
            }
          }
          this.courseData.sort(compare('pp_date'))
        })
        .catch(res => { });
    },
    gotoLectureManage(){
      this.$router.replace('/competition/competitionData')
    },
    gotoLecture(type) {
      if (type == 1){
        this.$router.replace('/competition/resultQuery')
      }else{
        this.$router.replace('/evaluation/resultQuery')
      }
      
    },
    gotoCourse() {
      this.$router.replace('/courseManage/courseManage')
    },
    openLectureDetail(row) {
      this.lectureContent = row;
      this.showLectureDetail = true;
    },
    openCourseDetail(row) {
      this.courseContent = row;
      this.showCourseDetail = true;
    }
  },
  mounted() {
    this.refreshLectureData();
    this.refreshCourseData();
    this.refreshCardData();
  }
};
</script>

<style scoped>
/deep/ .el-table__body-wrapper {
  &::-webkit-scrollbar {
    width: 0px;
    border: none;
  }

  &::-webkit-scrollbar-track {
    border: none;
  }
}

/deep/ .el-table th.gutter {
  display: none;
  width: 0
}

/deep/ .el-table colgroup col[name='gutter'] {
  display: none;
  width: 0;
}

/deep/ .el-table__body {
  width: 100%;
}

/* 修改表格中每一行的横线样式 */

/* /deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
  border: 5px;
  border-bottom: 10px red;
} */
/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell.is-leaf {
  border-width: 3px !important;
  border-color: rgb(247, 247, 247) !important;
  /* 将横线颜色设置为红色，你可以根据需要修改颜色值 */
}

.card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex: 2;
}

.text-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex: 4;
}

.hvr-grow-shadow {
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow, transform;
  transition-property: box-shadow, transform;
}

.hvr-grow-shadow:hover,
.hvr-grow-shadow:focus {
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.hvr-grow-shadow:active {
  opacity: 0.8;
  /* 设置透明度为0.8，使元素的颜色变淡 */
}

.custom-form-item {
  height: 25px;
}

/* 取消鼠标移入行的颜色变化 */
/deep/.el-table .hover-row {
  background-color: transparent !important;
}
</style>